__turbopack_context__.v({
  "contactForm": "ContactForm-module-scss-module__taHw8a__contactForm",
  "email": "ContactForm-module-scss-module__taHw8a__email",
  "field": "ContactForm-module-scss-module__taHw8a__field",
  "fieldGroup": "ContactForm-module-scss-module__taHw8a__fieldGroup",
  "message": "ContactForm-module-scss-module__taHw8a__message",
  "name": "ContactForm-module-scss-module__taHw8a__name",
  "submitButton": "ContactForm-module-scss-module__taHw8a__submitButton",
});
